import React from 'react';
import styled, { css } from 'styled-components';
import '../styles.css';

import Subtitle from './common/Subtitle';
import Button from './common/Button';
import { COLORS, SIZE } from './common/constants';
import { FaLinkedinIn, FaGithub, FaBehance, FaMediumM } from 'react-icons/fa';

import profile from '../img/profile.png';
import profileBlush from '../img/profile--blush.png';

const Profile = () => {
	return (
		<>
			<StyledContainer>
				<Intro>
					<Title>Hello, I am Dasom Won</Title>
					<Subtitle subtitle='Frontend Engineer @Spectrm'></Subtitle>
				</Intro>
				<a
					target='_blank'
					rel='noopener noreferrer'
					href='https://instagram.com/kinogehen?igshid=1r37m32tflayc'
				>
					<ProfilePic />
				</a>
			</StyledContainer>
			<Footer>
				<LinkList>
					<a
						href='https://www.linkedin.com/in/dasom-won-8a1594190/'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Link>
							<FaLinkedinIn style={{ fontSize: '1.6rem' }} />
						</Link>
					</a>
					<a
						href='https://github.com/wondasom'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Link>
							<FaGithub style={{ fontSize: '1.6rem' }} />
						</Link>
					</a>
					<a
						href='https://www.behance.net/wondasom'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Link>
							<FaBehance
								style={{
									fontSize: '2.05rem',
									position: 'relative',
									top: '-4px'
								}}
							/>
						</Link>
					</a>
					<a
						href='https://medium.com/@wondasom93'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Link>
							<FaMediumM
								style={{
									fontSize: '1.7rem',
									position: 'relative',
									top: '-2px'
								}}
							/>
						</Link>
					</a>
				</LinkList>
			</Footer>
		</>
	);
};

export default Profile;

// 🎨 Styled Components
const StyledContainer = styled.div`
	width: 100%;
	background-color: inherit;
	margin: 0px auto;
	padding: 0 2rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	@media (max-width: ${SIZE.medium}) {
		flex-direction: column;
	}
	@media (max-width: ${SIZE.small}) {
		width: 90%;
		padding: 0;
	}
`;

const Intro = styled.div``;

const Title = styled.h1`
	font-size: calc(30px + (36 - 30) * ((100vw - 300px) / (1600 - 300)));
	padding-bottom: 0.625rem;
	font-family: myriad-pro, sans-serif;
	font-weight: 700;
	text-align: left;
	color: ${COLORS.grey};
	${(props) =>
		props.isDarkModeOn &&
		css`
			color: ${COLORS.white};
		`}
	&::selection {
		background-color: ${COLORS.somOrange};
		color: ${COLORS.white};
	}
`;

const ProfilePic = styled.div`
	width: 25rem;
	height: 25rem;
	background-image: url(${profile});
	background-size: 130%;
	background-repeat: no-repeat;
	background-position: center;
	@media (max-width: ${SIZE.large}) {
		width: 22rem;
		height: 22rem;
	}
	@media (max-width: ${SIZE.medium}) {
		width: 18rem;
		height: 18rem;
	}
	@media (max-width: ${SIZE.small}) {
		width: 14rem;
		height: 14rem;
	}
	&:hover {
		background-image: url(${profileBlush});
	}
`;

const Footer = styled.div`
	width: 100%;
	height: 3em;
	display: flex;
	align-items: flex-end;
	@media (max-width: ${SIZE.small}) {
		visibility: hidden;
	}
`;

const LinkList = styled.ul`
	height: 2em;
	display: flex;
	flex-direction: row;
`;

const Link = styled.li`
	padding-right: 2em;
	color: ${COLORS.lightGrey};
	&:hover {
		color: ${COLORS.somGreen};
	}
`;
